import { SWITCH_MENU_GENERAL } from "./actionTypes";

export const switchVisibilitatMenuLateral = () => {
  return {
    type: SWITCH_MENU_GENERAL
  };
};
